<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <tabela-dentistas title="Dentistas"></tabela-dentistas>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import TabelaDentistas from '@/views/Tables/TabelaDentistas'
  export default {
    name: 'tables',
    components: {
      TabelaDentistas
    }
  };
</script>
<style></style>
